export default __webpack_public_path__ + "static/media/collectible_icon.812a2cf6.svg";